<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('common.create')} ${$t('warehouse.one-item')}`
          : `${$t('common.edit')} ${$t('warehouse.one-item')}`
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group :label="$t('common.name')" label-for="name">
              <b-form-input
                v-model="EditForm.name"
                :placeholder="$t('common.name')"
              />
              <p class="text-danger mt-1">{{ errorForm.name }}</p>
            </b-form-group>
          </b-col>
          <b-col md="">
            <CategoryModal
              :isPharmacy="$route.name.includes('pharmacy') ? true : false"
              @category="assignCategoryInForm"
              :id="EditForm.category_id"
            />
            <p class="text-danger mt-1">{{ errorForm.category_id }}</p>
          </b-col>
          <b-col  md=""   style="font-weight: bold" v-if="$route.name.includes('pharmacy') ? true : false">
            <AutoComplete
              v-model="EditForm.drug_scientific_name_id"
              :label="$t('pharmacy.scientific-drugs-names')"
              :placeholder="$t('pharmacy.scientific-drugs-names')"
              param-query="name"
              :serializer="(val) => val.id"
              endpoint="drugScientificName"
              text-title="name"
              keyword="name"
            />
          </b-col>
          <b-col md=""  v-if="$route.name.includes('pharmacy') ? false : true">
            <b-form-group
              :label="$t('warehouse.minimum-reorder-quantity')"
              label-for="minimum_reorder_quantity"
             
            >
              <b-form-input
                
                v-model="EditForm.minimum_reorder_quantity"
                :placeholder="$t('warehouse.minimum-reorder-quantity')"
                type="number"
              />
              <p class="text-danger mt-1">
                {{ errorForm.minimum_reorder_quantity }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t("common.add") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-card :title="$t('warehouse.item')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("common.filter") }} {{ $t("warehouse.item") }}</h2>
            <br />
          </b-col>

          <b-col md="3" cols="12">
            <b-form-group :label="$t('common.name')" label-for="Name">
              <b-form-input
                id="Name"
                v-model="itemName"
                :placeholder="$t('common.name')"
              />
            </b-form-group>
          </b-col>
          <b-col v-if="!this.$route.params.id" md="3" cols="12">
            <AutoComplete
              v-model="selectedSubcategory"
              :label="$t('warehouse.category')"
              :placeholder="$t('warehouse.category')"
              :serializer="(val) => val"
              endpoint="category-list"
              text-title="name"
              @input="assignCategoryFilter"
              :other-query="`filter[type]=${
                this.$route.name.includes('pharmacy') ? 'pharmacy' : 'hospital'
              }`"
            />
          </b-col>
          <b-col  md="3" cols="12"   style="font-weight: bold" v-if="$route.name.includes('pharmacy') ? true : false">
            <AutoComplete
              v-model="drug_scientific_name_id"
              :label="$t('pharmacy.scientific-drugs-names')"
              :placeholder="$t('pharmacy.scientific-drugs-names')"
              param-query="name"
              :serializer="(val) => val.id"
              endpoint="drugScientificName"
              text-title="name"
              keyword="name"
            />
          </b-col>
          <b-col
            md="2"
            cols="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getItemsList()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>

        <!-- Search Button -->

        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("common.table") }} {{ $t("warehouse.item") }}</h2>
          <b-button
            v-if="$store.state.app.permissions.includes('store-item')"
            variant="primary"
            @click="show(EditForm, 'create')"
          >
            {{ $t("common.create") }} {{ $t("warehouse.one-item") }}
          </b-button>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <ActionsButtons
                deletePerm="delete-item"
                editPerm="update-item"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                {{ $t("warehouse.one-item") }}</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getItemsList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
const CategoryModal = () => import("@/components/warehouse/CategoryModal.vue");
const CategoryFilterModal = () =>
  import("@/components/warehouse/CategoryFilterModal.vue");
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BLink,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    StatisticCardHorizontal,
    CategoryModal,
    CategoryFilterModal,
    ActionsButtons,
    DeleteModal,
    AutoComplete,
  },
  data() {
    return {
      categoryFilter: {
        name: "",
        id: "",
      },
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        name: "",
        category_id: "",
        drug_scientific_name_id: "",
        minimum_reorder_quantity: null,
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        name: "",
        category_id: "",
        minimum_reorder_quantity: "",
        drug_scientific_name_id: "",
      },
      params: {
        form: {},
        path: "",
      },
      baseTableColumns: [
        { key: "name", label: this.$t("common.name"), sortable: true },
        {
          key: "category.name",
          label: this.$t("warehouse.one-category"),
          sortable: true,
        },
        {
          key: "drug_scientific_name.name",
          label: this.$t("pharmacy.scientific-drugs-names"),
          sortable: true,
        },
        {
          key: "minimum_reorder_quantity",
          label: this.$t("warehouse.minimum-reorder-quantity"),
          sortable: true,
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      isPharmacy: this.$route.name.includes("pharmacy") ? true : false,
      drug_scientific_name_id: "",
    };
  },
  computed: {
    tableColumns() {
      if (this.isPharmacy) {
        return this.baseTableColumns.filter(column => column.key !== 'minimum_reorder_quantity')
      } else {
        return this.baseTableColumns.filter(column => column.key !== 'drug_scientific_name.name')
      }
    }
  },
  mounted() {
    this.getItemsList();
  },
  methods: {
    assignCategoryFilter(v) {
      this.categoryFilter = v;
    },
    assignCategoryInForm(v) {
      this.EditForm.category_id = v.id;
    },
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          name: "",
          category_id: "",
          minimum_reorder_quantity: null,
          drug_scientific_name_id: null,
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.name = item.name;
        this.EditForm.category_id = item.category_id;
        this.EditForm.minimum_reorder_quantity = item.minimum_reorder_quantity;
        this.EditForm.drug_scientific_name_id = item.drug_scientific_name_id;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
      this.$bvModal.hide("category-modal");
    },

    async getItemsList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/item?filter[type]=${
        this.$route.name.includes("pharmacy") ? "pharmacy" : "hospital"
      }&page=${this.page}&take=${this.take}&sort=-id&include=category`;

      if (this.$route.params.id) {
        url += `&filter[category_id]=${this.$route.params.id}`;
      }

      if (this.isPharmacy) {
        url += `&filter[drug_scientific_name_id]=${this.drug_scientific_name_id || ''}&include=drugScientificName,category`;
      }

      if (this.itemName) {
        url += `&filter[name]=${this.itemName}`;
      }
      if (this.categoryFilter) {
        url += `&filter[category_id]=${this.categoryFilter.id}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/item/${this.deleteForm.id}`)
        .then((response) => {
          this.getItemsList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      let count = 0;
      this.loading = true;
      this.errorForm.name = "";
      this.errorForm.category_id = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (!this.EditForm.name) {
        this.errorForm.name = "The name field is required.";
        count++;
      }

      if (!this.EditForm.category_id) {
        this.errorForm.category_id = "The category field is required.";
        count++;
      }

      if (count > 0) {
        this.loading = false;
        return false;
      }

      this.EditForm.type = this.$route.name.includes("pharmacy")
        ? "pharmacy"
        : "hospital";

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/item`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.loading = false;
              this.$bvModal.hide("modal-edit");
              this.getItemsList();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/item/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.loading = false;
              this.$bvModal.hide("modal-edit");
              this.getItemsList();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
